import React, { useState, Suspense } from 'react';
import { Text, Spinner, SpinnerSize } from '@bechtel/gds';
import {
  TabButtonStyled,
  ProjectAdminContainerStyled,
  ProjectAdminHeaderStyled,
  ProjectAdminTabStyled,
} from '../styled';
import { workPackageAdminTabList } from './tab-data';
import { WorkPackageAdminTab, WorkPackageAdminTabType } from './types';
import { map } from 'lodash';
import { ErrorBoundary } from '@bechtel/client-common';
import { WorkPackageDisciplines } from './disciplines';
import { ImportWorkPackages } from './import';
import WorkPackagCard from './card';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';

export const WorkPackageAdmin = () => {
  const [selectedTab, setSelectedTab] = useState<WorkPackageAdminTabType>(WorkPackageAdminTabType.DISCIPLINES);
  const { i18n } = useLingui();
  return (
    <ProjectAdminContainerStyled>
      <ProjectAdminHeaderStyled>
        <Text family="graphik" size="600" weight="600" color="white">
          <Trans>Work Packages</Trans>
        </Text>
      </ProjectAdminHeaderStyled>
      <ProjectAdminTabStyled>
        {map(workPackageAdminTabList, (tabItem: WorkPackageAdminTab) => {
          return (
            <TabButtonStyled
              selected={tabItem.value === selectedTab}
              onClick={() => {
                setSelectedTab(tabItem.value);
              }}
              key={tabItem.value}
            >
              {i18n._(tabItem.label)}
            </TabButtonStyled>
          );
        })}
      </ProjectAdminTabStyled>
      {selectedTab == WorkPackageAdminTabType.DISCIPLINES && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <WorkPackageDisciplines />
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == WorkPackageAdminTabType.CARD && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <WorkPackagCard />
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == WorkPackageAdminTabType.IMPORT && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <ImportWorkPackages />
          </Suspense>
        </ErrorBoundary>
      )}
    </ProjectAdminContainerStyled>
  );
};
